import { Injectable } from '@angular/core';
import { FormBuilderBackendService } from 'form-builder';
import { Observable } from 'rxjs';
import { QuestionPaperDesignContext, QuestionPaperAttemptContext, QuestionPaperEvaluateContext } from 'form-builder';
import { QuestionPaperSchemaDefn } from 'form-builder/lib/model/question-paper';
import { Answer, EvaluationResult } from 'form-builder';
import { AppSettings } from 'src/app/utils/app-settings';
import { HttpClient } from '@angular/common/http';


@Injectable()
export class ExamBackendService extends FormBuilderBackendService {

  constructor(private http: HttpClient) { super(); }

  getQuestionPaperDesignContext(questionPaperId: number): Observable<QuestionPaperDesignContext> {
    throw new Error("Method not implemented.");
  }
  saveQuestionPaperSchema(questionPaperId: number, qData: QuestionPaperSchemaDefn): Observable<any> {
    throw new Error("Method not implemented.");
  }
  getQuestionPaperAttemptContext(attemptKey: string): Observable<QuestionPaperAttemptContext> {
    return this.http.get<QuestionPaperAttemptContext>(`${AppSettings.apiUrl}attempt/${+attemptKey}`);
  }
  saveAnswers(attemptKey: string, answers: Answer[]) {
    return this.http.post(`${AppSettings.apiUrl}attempt/${+attemptKey}/answers`, answers);
  }
  getAnswers(attemptKey: string, questions: string[]): Observable<Answer[]> {
    let qNames = questions.join(',');
    return this.http.get<Answer[]>(`${AppSettings.apiUrl}attempt/${+attemptKey}/answers?questions=${qNames}`)
  }
  getAttemptStatus(attemptKey: string): Observable<{ timeRemaining: number; }> {
    throw new Error("Method not implemented.");
  }
  getQuestionPaperEvalContext(attemptKey: string): Observable<QuestionPaperEvaluateContext> {
    throw new Error("Method not implemented.");
  }
  saveEvalResults(attemptKey: string, evaluation: EvaluationResult, marks_scored: number, isEvalComplete: boolean) {
    throw new Error("Method not implemented.");
  }

}
